// extracted by mini-css-extract-plugin
module.exports = {"brandGRDLogo":"style_brandGRDLogo__lY_rd"};